<section>
  <div class="border_container">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 container-style p-2">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mb-2">
        <app-custom-button [title]="'Regresar'" [label]="'Nuevo'" (onClick)="createNew()" [severity]="'success'"
          [variant]="undefined" [disabled]="disabledDetail" [icon]="'pi pi-plus'"
          [width]="'5.5rem'"></app-custom-button>
      </div>
      <div [hidden]="!isFormView" class="col-lg-12 col-md-12 col-sm-12 col-12 border py-1 px-2">
        <app-register-enterprise-city [enterpriseContract]="enterpriseContract"
          [enterpriseCityContract]="enterpriseCityContract" [disabled]="disabledDetail"
          (updateListDetail)="getAllEnterpriseCitiesWithPagination()" (isFormView)="getFormView($event)">
        </app-register-enterprise-city>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-custom-table [headers]="header" [data]="data" [actions]="tableActions"
          [showCheckbox]=" !this.disabledDetail " [checkBoxAction]="checkboxActions"
          [clearSelectionTrigger]="clearSelectionTrigger" (onPageChange)="onPageChange($event)"
          (onRecoverData)="getAllEnterpriseCitiesWithPagination()" (onAction)="onAction($event)"></app-custom-table>
      </div>
    </div>
  </div>
</section>